import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  createProductClassification,
  editProductClassification,
} from "services";
import { useProdClassificationStore } from "../stores/ProductClassificationStore";
import { validateYupStringWithSpecialCharacters } from "helpers/functionsHelpers";
import { NotificationType, showNotifications } from "helpers/toas_notification";

export const useFormModal = (onHide: () => void) => {
  const { t } = useTranslation();

  const queryClient = useQueryClient();

  const { isEdit, productClassification } = useProdClassificationStore();

  const initialValues = {
    description: productClassification?.description || "",
  };

  const valdiationSchema = Yup.object({
    description: validateYupStringWithSpecialCharacters(t, false),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: valdiationSchema,
    onSubmit: (values) => {
      const payload = {
        description: values.description,
      };

      if (isEdit && productClassification) {
        edithPrdClassification(payload, productClassification.id);
      } else {
        createPrdClassification(payload);
      }
    },
  });

  const edithPrdClassification = async (payload: any, id: number) => {
    try {
      const responseEdit = await editProductClassification(payload, id);

      if (responseEdit.code === "200") {
        showNotifications(
          NotificationType.SUCCESS,
          t("notificationsMessages.success")
        );

        queryClient.invalidateQueries({
          queryKey: ["getProductClasification"],
        });

        resetForm();
      } else {
        showNotifications(
          NotificationType.ERROR,
          t("notificationsMessages.error") +
            " " +
            responseEdit.message.toLowerCase()
        );
      }
    } catch (error) {
      showNotifications(
        NotificationType.ERROR,
        t("notificationsMessages.error") + " " + error
      );
    }
  };

  const createPrdClassification = async (payload: any) => {
    try {
      const respCreate = await createProductClassification(payload);

      if (respCreate.code === "200") {
        showNotifications(
          NotificationType.SUCCESS,
          t("notificationsMessages.successTwo")
        );
        resetForm();
        queryClient.invalidateQueries({
          queryKey: ["getProductClasification"],
        });
      } else {
        showNotifications(
          NotificationType.ERROR,
          t("notificationsMessages.error") +
            " " +
            respCreate.message.toLowerCase()
        );
      }
    } catch (error) {
      showNotifications(
        NotificationType.ERROR,
        t("notificationsMessages.error") + " " + error
      );
    }
  };

  const resetForm = () => {
    formik.resetForm();
    onHide();
  };

  return {
    t,
    isEdit,
    formik,
    resetForm,
  };
};
